import { Step } from "react-joyride";
import { TFunction } from "i18next";

import { DraftReplies } from "@/enum/draft-replies.enum";

export type TourStepFactory = (t: TFunction, context?: Record<string, unknown>) => Step[];

export type TourDefinition = {
	steps: TourStepFactory;
	nextTour?: string;
	navigateOnFinish?: string;
};

export const tourRegistry: Record<string, TourDefinition> = {
	"draft-replies": {
		steps: (t, context) => {
			const draftReplies = context?.draftReplies as DraftReplies | undefined;

			return [
				...(draftReplies === DraftReplies.THREE
					? [
							{
								target: '[data-tour="draft-reply-card"]',
								title: t("inbox.tour.draftCardTitle"),
								content: t("inbox.tour.draftCardContent"),
								disableBeacon: true,
								placement: "left" as const,
							},
						]
					: []),
				{
					target: '[data-tour="draft-reply-editor"]',
					title: t("inbox.tour.draftEditorTitle"),
					content: t("inbox.tour.draftEditorContent"),
					disableBeacon: true,
					placement: "top" as const,
				},
				{
					target: "body",
					title: t("inbox.tour.draftSettingsNavTitle"),
					content: t("inbox.tour.draftSettingsNavContent"),
					disableBeacon: true,
					placement: "center" as const,
				},
			];
		},
		nextTour: "draft-replies-settings",
		navigateOnFinish: "/app/company",
	},
	"draft-replies-settings": {
		steps: (t) => [
			{
				target: '[data-tour="draft-replies-dropdown"]',
				title: t("inbox.tour.draftSettingsTitle"),
				content: t("inbox.tour.draftSettingsContent"),
				disableBeacon: true,
				placement: "bottom" as const,
			},
		],
	},
};
